export enum ProcessEnum {
  DEFAULT_PROCESS,
  NORMAL,
  // ON_HOLD_PROCESS,
  // OPEN_PROCESS,
  // REJECTED_PROCESS,
  // ACCEPTED_PROCESS,
  CLOSED_PROCESS,
  // APPEAL_PROCESS,
  // DROP_PROCESS
}
export namespace ProcessEnum {
  export function keys(): Array<string> {
    var keys = Object.keys(ProcessEnum);
    return keys.slice(keys.length / 2, keys.length - 1);
  }
}